import { IEvent } from "@quest/adapter-interface";
import {  Graphics } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { dispatcher, ingenuity } from "@quest/base-core/dist/Namespace";
import { Container } from "@quest/base-core/dist/ui/Container";
import { BaseViewBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class ReSpinIntroOutroView extends BaseViewBehavior {
  // public outroRespinContainer: Container;
  public outroTextMainContainer: Container;
  private baseGameMask: Graphics;
  private reSpinIntroMainContainer: Container;
  //override to resize view during broken
  protected initializeComponents(): void {
    super.initializeComponents();
    this.outroTextMainContainer = this.getContainerByID("outroTextMainContainer");
    // this.outroRespinContainer = this.getContainerByID("outroRespinContainer");
    this.reSpinIntroMainContainer = this.getContainerByID("reSpinIntroMainContainer");
  }
  /**
   *TODO: do not remove the supered code as used to call resize from class end the resize dispatcher off issue
   * will fix and verify
   */
  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      let scale = 0;
      this.pivot.set(ingenuity.configData.height / 2, ingenuity.configData.width / 2);
      scale = Math.max(innerHeight / ingenuity.configData.width, innerWidth / ingenuity.configData.height);
      this.scale.set(scale);
      if (this.reSpinIntroMainContainer) {
        (this.reSpinIntroMainContainer.mask as Graphics) = null;
      }
    }else {
      this.baseGameMask = this.getShapeById("baseGameMask") as Graphics;
      if (this.reSpinIntroMainContainer) {
        (this.reSpinIntroMainContainer.mask as Graphics) = this.baseGameMask;
      }
    }
  }
  public addViewToTop(): void {
    ingenuity.currentGame.stage.addChild(this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }
}
